import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, Grid, Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPhotosById } from '../../../../asiosConfig';
import { toast } from 'react-toastify';

export const ViewUserImages = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const userId = location.state?.userId;
    const [photos, setPhotos] = useState([]);
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const fetchPhotos = async () => {
            // const token = localStorage.getItem('token');
            try {
                const response = await getPhotosById({ 'user_id': userId });
                if (response.status === 200 || response.status === 201) {
                    setPhotos(response.data.data);
                } else {
                    toast.error("Error Fetching Photos");
                }
            } catch (error) {
                toast.error("Error Fetching Photos");
            }
        };
        fetchPhotos();
    }, [userId]);

    const openModal = (index) => {
        setCurrentPhotoIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleNext = () => {
        if (photos.length > 0) {
            setCurrentPhotoIndex((prevIndex) => (prevIndex + 1) % photos.length);
        }
    };

    const handlePrevious = () => {
        if (photos.length > 0) {
            setCurrentPhotoIndex((prevIndex) => (prevIndex - 1 + photos.length) % photos.length);
        }
    };

    return (
        <div className="col-lg-9 col-12">
            <Card className="editProfileBlock">
                <CardHeader
                    avatar={<ArrowBack sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
                    title="Photos"
                    titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
                />
                <CardContent>
                    {photos.length === 0 ? (
                        <Typography variant="body1" align="center">No photos found</Typography>
                    ) : (
                        <Grid container spacing={2}>
                            {photos.map((photo, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <Card>
                                        <CardContent sx={{ padding: 1 }}>
                                            <img
                                                src={photo?.photo ? photo.photo : 'No Image'}
                                                alt="Photo"
                                                style={{ width: '100%', height: '270px', cursor: 'pointer', objectFit: 'cover' }}
                                                onClick={() => openModal(index)}
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </CardContent>
            </Card>

            <Dialog
                open={isModalOpen}
                onClose={closeModal}
                maxWidth="md"
                fullWidth
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    '& .MuiPaper-root': {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        margin: 0,
                        padding: 0,
                    },
                }}
            >
                <DialogTitle>
                    <IconButton aria-label="close" onClick={closeModal} sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center', position: 'relative' }}>
                    {photos.length > 0 && currentPhotoIndex !== null && photos[currentPhotoIndex] && (
                        <img
                            src={photos[currentPhotoIndex]?.photo || 'No Image'}
                            alt="Current"
                            style={{ maxHeight: '80vh', maxWidth: '100%' }}
                        />
                    )}
                    <IconButton onClick={handlePrevious} sx={{ position: 'absolute', top: '50%', left: 8, transform: 'translateY(-50%)', color: 'white' }}>
                        <ArrowBack />
                    </IconButton>
                    <IconButton onClick={handleNext} sx={{ position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)', color: 'white' }}>
                        <ArrowForward />
                    </IconButton>
                </DialogContent>
            </Dialog>
        </div>
    );
};
